import React, { useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import ColdCallForm from "./ColdCallForm"

const AddColdCall = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "",
  })

  const handleSubmit = () => {
    console.log("Add Cold Call:", formData)
  }

  return (
    <div className="page-content">
      <Breadcrumb
        title="Cold Calling Management"
        breadcrumbItem="Add Contact"
      />
      <Card>
        <CardBody>
          <ColdCallForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default AddColdCall
